// extracted by mini-css-extract-plugin
export default {"table-cell":"TableSkeleton_table-cell__OzD9Y","tr":"TableSkeleton_tr__JdkSs","table-row":"TableSkeleton_table-row__3xpI9"};